import { gql } from "apollo-boost";

export const GET_SETTING_BY_SHOP = gql`
query SettingByShopId($where: SettingWhereInput) {
  settingByShopId(where: $where) {
    id
    pointRate
    taxes {
      taxStatus
      tax
      taxType
    }
    stockInOut
    shippingCost
    splitAmountOrder
    printBillA4
    editPriceBeforeSale
    editOrderAfterSale
  }
}
  ` 
export const GET_SETTING_BY_SHOP_V2 = gql`
query SettingByShopIdV2($where: SettingWhereInput) {
  settingByShopIdV2(where: $where) {
    id
    pointRate
    taxes {
      taxStatus
      tax
      taxType
    }
    stockInOut
    shippingCost
    splitAmountOrder
    printBillA4
    editPriceBeforeSale
    editOrderAfterSale
  }
}
  ` 